export default class MissingValue extends Error {
    constructor(parameterName) {
        super(`Required value missing: ${parameterName}`);
    }
}
